import { render, staticRenderFns } from "./VrInfo.vue?vue&type=template&id=049c433f&"
import script from "./VrInfo.vue?vue&type=script&lang=js&"
export * from "./VrInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev ii\\my work\\seo-team-flow\\vue templates\\Vuetify Soft UI Dashboard PRO\\seo-team-flow-ii\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('049c433f')) {
      api.createRecord('049c433f', component.options)
    } else {
      api.reload('049c433f', component.options)
    }
    module.hot.accept("./VrInfo.vue?vue&type=template&id=049c433f&", function () {
      api.rerender('049c433f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Dashboard/VrInfo.vue"
export default component.exports